<div class="modal-header">
  <h4 class="modal-title">ONBOARDING REQUEST</h4>
  <button type="button" class="btn-close"
          aria-hidden="true" (click)="modalCancel()">
  </button>
</div>
<div class="modal-body">
  Please review and make any necessary updates before submitting your request
  <br />
  <br />
  <div *ngIf="!user" class="m-2 p-2 alert-danger">
    <span>Note: Unable to process the request due to missing user data. Try logging off and signing in again.</span>
  </div>
  <form #frmPositionRequest="ngForm">
    <nbc-modal-alert></nbc-modal-alert>
    <div class="row">

      <div class="col-md-12">
        <div class="form-box">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-4">
                  <b>Hiring Manager</b>
                  <input type="text"
                         [disabled]="true"
                         [(ngModel)]="hiringManger"
                         name="hiringManager"
                         class="form-control req-modal"
                         placeholder=""
                         maxlength="100" />
                </div>

                <div class="col-md-4">
                  <b>Business Units</b>
                  <div class="form-group">
                    <div [ngClass]="{'has-error': !businessUnit  && submitted && isRequiredValidation}">
                      <nbc-select *ngIf="businessUnits" name="bu"
                                  [nbcRequired]="true"
                                  [(model)]="businessUnit"
                                  [source]="onboardingMasterData?.businessUnits"
                                  display="description"
                                  value="id"
                                  placeHolderDisplay="--Select--"
                                  placeHolderValue="null">
                      </nbc-select>
                      <span class="control-label control-label-error" *ngIf="!businessUnit?.id && isRequiredValidation && submitted">
                        Business Unit is required.
                      </span>

                    </div>
                      
                    </div>
                  </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-4">
                  <b>Reports To</b>
                  <div [ngClass]="{'has-error': !reportsToManager  && submitted && isRequiredValidation}">
                  <nbc-select *ngIf="onboardingMasterData"
                              name="reportsToManager"
                              [source]="onboardingMasterData?.reportTo"
                              [(model)]="reportsToManager"
                              [nbcRequired]="true"
                              [customErrorClass]="(!onboardingMasterData?.reportTo?.id && submitted) ? 'nbc-control-error':''"
                              display="description"
                              value="id"
                              placeHolderDisplay="--Select--"
                              placeHolderValue="null">
                  </nbc-select>
                  <span class="control-label control-label-error" *ngIf="!reportsToManager?.id && isRequiredValidation && submitted">
                    Reports To is required.
                  </span>
                  </div>

                </div>

                <div class="col-md-4">
                  <b>Proxy</b>
                  <div class="form-group">
                    <nbc-select *ngIf="onboardingMasterData" name="bu"
                                [source]="onboardingMasterData.proxy"
                                [(model)]="proxy"
                                display="description"
                                value="id"
                                placeHolderDisplay="--Select--"
                                placeHolderValue="null"
                                (change)="proxySelected(proxy)" >
                    </nbc-select>
                  </div>
                </div>
                <div class="col-md-4">
                  <br />
                  <div class="form-group">
                    <span style="color:red" *ngIf="proxyEmail"> {{proxyEmail}} </span>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
        </div>
          <br />
          <div class="col-md-12">
            <div class="row"
                 style="margin-left:1px">
              <div class="col-md-4">
                <b>Position Start Date</b>  

                <div class="form-group"
                     [ngClass]="{'has-error': !positionStartDate && submitted && isRequiredValidation}">
                  <div class="form-group">
                    <div class="input-group input-group-set"
                         date-time-append>
                      <span class="input-group-text"><i class="fa fa-calendar"></i></span>

                      <input type="text"
                             name="positionStartDate"
                             class="form-control activity-date-focus req-modal"
                             ngModel
                             required
                             bsDatepicker
                             [(bsValue)]="positionStartDate"
                             #drp="bsDatepicker"
                             placeholder="Position Start Date"
                             [(ngModel)]="positionStartDate"
                             [bsConfig]="{ isAnimated: true, dateInputFormat: 'MM/DD/YYYY', customTodayClass:'custom-today-class'}" />

                    </div>
                    <span class="control-label control-label-error"
                          *ngIf="!positionStartDate && isRequiredValidation && submitted ">
                      Position Start Date is required.
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <b>Company Code</b>
                <div class="form-group">
                  <div [ngClass]="{'has-error': !companyCode?.id && submitted && isRequiredValidation}">
                    <nbc-select *ngIf="onboardingMasterData"
                                name="companyCodeDDl"
                                [source]="onboardingMasterData.companyCodes"
                                [(model)]="companyCode"
                                [nbcRequired]="true"
                                [customErrorClass]="(!companyCode?.id && submitted) ? 'nbc-control-error':''"
                                display="description"
                                value="id"
                                placeHolderDisplay="Select a Company Code"
                                placeHolderValue="null">
                    </nbc-select>
                    <span class="control-label control-label-error"
                          *ngIf="!companyCode?.id && isRequiredValidation && submitted">
                      Company Code is required.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row"
                 style="margin-left:1px">
              <div class="col-md-4">
                <b>Employee Type</b>
                <div class="form-group">
                  <div [ngClass]="{'has-error': !postionType?.id && submitted}">
                    <nbc-select *ngIf="onboardingMasterData"
                                name="positionTypeDDl"
                                [source]="onboardingMasterData.employeeTypes"
                                [(model)]="postionType"
                                [nbcRequired]="true"
                                [customErrorClass]="(!postionType?.id && submitted) ? 'nbc-control-error':''"
                                display="description"
                                value="id"
                                placeHolderDisplay="Select a Position Type"
                                placeHolderValue="null">
                    </nbc-select>

                    <span class="control-label control-label-error"
                          *ngIf="!postionType?.id && isRequiredValidation && submitted">Position Type is required.</span>

                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <b>FLSA Status</b>
                <div class="form-group">
                  <div [ngClass]="{'has-error': !flsaStatus?.id && submitted && isRequiredValidation}">
                    <nbc-select *ngIf="onboardingMasterData"
                                name="flsaDDL"
                                [source]="onboardingMasterData.flsaStatus"
                                [(model)]="flsaStatus"
                                [nbcRequired]="true"
                                [customErrorClass]="(!flsaStatus?.id && submitted) ? 'nbc-control-error':''"
                                display="description"
                                value="id"
                                placeHolderDisplay="Select FLSA"
                                placeHolderValue="null">
                    </nbc-select>
                    <span class="control-label control-label-error"
                          *ngIf="!flsaStatus?.id && isRequiredValidation && submitted">FLSA Status is required.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-box">
              <h4>Employee Details</h4>
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12">
                      <b>Email</b>
                      <div class="form-group">
                        <input type="text"
                               name="email"
                               value="{{contact.email}}"
                               class="form-control req-modal"
                               placeholder=""
                               maxlength="100"
                               [disabled]="true" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-4">
                      <b>First Name</b>
                      <div class="form-group">
                        <input type="text"
                               name="firstName"
                               value="{{contact.firstName}}"
                               class="form-control req-modal"
                               placeholder=""
                               maxlength="100"
                               [disabled]="true" />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <b>Middle Name</b>
                      <div class="form-group">
                        <input type="text"
                               name="contactMiddleName"
                               value="{{contact.middleName}}"
                               class="form-control req-modal"
                               placeholder=""
                               maxlength="100"
                               [disabled]="true" />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <b>Last Name</b>
                      <div class="form-group">
                        <input type="text"
                               name="lastName"
                               value="{{contact.lastName}}"
                               class="form-control req-modal"
                               placeholder=""
                               maxlength="100"
                               [disabled]="true" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-4">
                      <b>State of Legal Residence</b>
                      <div class="form-group" *ngIf="onboardingMasterData">
                        <div> 
                          <div [ngClass]="{'has-error': !state && submitted && isRequiredValidation}">
                          <select name="stateOfLegalResidence"
                                  class="form-select"
                                  [(ngModel)]="state"
                                  required>
                            <option [ngValue]="null">--Select--</option>
                            <option *ngFor="let state of onboardingMasterData.states" [ngValue]="state.code">{{state.name}}</option>
                          </select>
                          <span *ngIf="!state && submitted && isRequiredValidation"
                                class="control-label control-label-error">
                            State is required.
                          </span>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
</form>
  After submitting this form the included Contacts will be notified and directed to the Registration Portal to begin
  the onboarding process.
</div>
<div class="modal-footer text-left col-md-12 d-flex justify-content-between align-items-center">
  <div class="col-md-6">  
    <button type="submit" class="btn btn-primary"
            (click)="isRequiredValidation = true;submitted=true;savePositionRequest(frmPositionRequest);"
            [disabled]="!user">
      Submit Request
    </button>
    <button type="button" class="btn btn-default" (click)="modalCancel()">
      Cancel
    </button>
  </div>  
</div>
